import { Injectable, Optional } from "@angular/core";
import { Firestore } from "@angular/fire/firestore";
import { ElasticSearchService, ESExtras } from "@common/api-server";
import { EsFirestoreBase } from "@common/helpers/es-firestore-base";
import { OrganizationModel } from "@shared/models/organization.model";

const ES_EXTRA: ESExtras = {
  'name': {
    type: "text"
  },
}

const ES_SOURCE = null; 
const DATE_PROPERTIES = ['createdAt', 'updatedAt']

export type Model = OrganizationModel;
const collectionName = 'organizations'
@Injectable({
  providedIn: 'root'
})
export class OrganizationDbService extends EsFirestoreBase<Model>{
  override collectionName = collectionName;
  constructor(
    @Optional() protected override firestore: Firestore,
    protected override es: ElasticSearchService,

  ) {
    super(firestore, es, collectionName, ES_EXTRA, ES_SOURCE, DATE_PROPERTIES);
  }

}